var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',_vm._b({attrs:{"type":"submit","variant":_vm.variant || 'primary',"disabled":_vm.busy || _vm.loading || _vm.disabled,"data-cy":_vm.dataCy},on:{"click":function($event){return _vm.$emit('click', $event)}}},'btn',{
    ..._vm.$attrs,
    size: _vm.size,
  },false),[_vm._t("default"),_vm._v(" "),_vm._t("submitText",function(){return [_vm._v(_vm._s(_vm.submitTxt))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }